
<div *ngIf="qID=='2'" class="m-multi-row" [formGroup]="borrower">
    <div class="form-row row">
      <button type="button" class="close" 
        aria-label="Close" 
        *ngIf="showRemove" 
        (click)="removed.emit(index)">
        <span aria-hidden="true">&times;</span>
      </button>
      <!--proximity-->
      <div class="row">
      <div class="form-group col-12 col-md-4">  
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.PROXIMITY"|translate}}
        </label>
        <select formControlName="borrowerProximity" 
        class="m-sm-form-control form-control"  
        [attr.aria-label]="'BORROWERS_DETAILS.QUESTION2.PROXIMITY'|translate">
          <option [value]="null">{{"BORROWERS_DETAILS.QUESTION2.PROXIMITY_PH"|translate}}</option>
          <option *ngFor="let prox of proximity" [value]="prox">{{prox}}</option>
        </select>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerProximity').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
      </div>
      <!--full name-->
      <div class="form-group col-12 col-md-4">
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.FULL_NAME"|translate}}
        </label>
        <input placeholder="{{'BORROWERS_DETAILS.QUESTION2.FULL_NAME'|translate}}" type="text" 
        formControlName="borrowerFullName" 
        class="m-sm-form-control form-control"  
        [attr.aria-label]="'BORROWERS_DETAILS.QUESTION2.FULL_NAME'|translate"/>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerFullName').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerFullName').hasError('pattern') && displayErrors">
          {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
        </small>
      </div>
       <!--TZ-->
       <div class="form-group col-12 col-md-4">
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.ID_NUM"|translate}}
        </label>
        <input placeholder="{{'BORROWERS_DETAILS.QUESTION2.ID_NUM'|translate}}" type="tel" maxlength="9" 
        formControlName="borrowerIdNumber" class="m-sm-form-control form-control" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION2.ID_NUM'|translate"/>
        <small class="m-error form-text" 
        *ngIf="borrower.get('borrowerIdNumber').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
        <small class="m-error form-text" 
        *ngIf="borrower.get('borrowerIdNumber').hasError('invalidId') && !borrower.get('borrowerIdNumber').hasError('required') && displayErrors">
          {{'COMMON.ID_PATTERN_ERROR' | translate }}
        </small>
      </div>
    </div>
    <div class="row">
      <!--phone-->
      <div class="form-group col-12 col-md-4">
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.TEL"|translate}}
        </label>
        <phone-number [customClass]="'borrower'" 
        formControlName="borrowerPhoneNumber" 
        [(isMobile)]="isMobilePhone" class="m-borrower" 
          [attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate" 
          [attr.aria-invalid]="!borrower.get('borrowerPhoneNumber').valid &&  displayErrors">
        </phone-number>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerPhoneNumber').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerPhoneNumber').hasError('minlength') && displayErrors">
          {{ 'COMMON.PHONE_MIN_CHARS' | translate }}
        </small>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerPhoneNumber').hasError('pattern') && displayErrors">
          {{ 'COMMON.PHONE_NUM_PATTERN_ERROR' | translate }}
        </small>
      </div>
      <!--birth date-->
      <div class="form-group col-12 col-md-4">
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.BIRTH_DATE"|translate}}
        </label>
        <div class="input-group m-datepicker" style="direction:ltr">
          <input class="form-control m-sm-form-control" 
          [minDate]="minBirthDate" 
          [maxDate]="maxBirthDate" 
          [firstDayOfWeek]=7 formControlName="borrowerBirthDate" 
          placeholder="dd/mm/yyyy"
            name="d1" ngbDatepicker #d1="ngbDatepicker"  
            [attr.aria-label]="'BORROWERS_DETAILS.QUESTION2.BIRTH_DATE'|translate">
            <div class="input-group-append">
              <button class="" (click)="d1.toggle()" type="button">
                <i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerBirthDate').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerBirthDate').hasError('invalidDate') && !borrower.get('borrowerBirthDate').hasError('required') && displayErrors">
          {{ 'COMMON.DATE_ERROR' | translate }}
        </small>
      </div>
      <!--email-->
      <div class="form-group col-12 col-md-4">
        <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION2.EMAIL"|translate}}
        </label>
        <input type="text" formControlName="borrowerEmail" 
          placeholder="{{'BORROWERS_DETAILS.QUESTION2.EMAIL_PH'|translate}}"
          class="m-sm-form-control form-control" 
          [attr.aria-label]="'BORROWERS_DETAILS.QUESTION2.EMAIL'|translate"/>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerEmail').hasError('required') && displayErrors">
          {{ 'COMMON.FIELD_REQUIRED' | translate }}
        </small>
        <small class="m-error form-text" *ngIf="borrower.get('borrowerEmail').hasError('pattern') && displayErrors">
          {{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
        </small>
      </div>
    </div>
      <input type="hidden" 
      formControlName="borrowerId" 
      class="d-none1" />
  </div>
</div>
<!--question 29-->
<!-- <div *ngIf="qID=='29'" class="m-multi-row" [formGroup]="borrower">
  <div class="form-row row text-center">
    <div class="form-group col-12 col-md-3">
      <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION29.NAME_TITLE"|translate}}
        </label>
      <input type="text" formControlName="borrowerFullName"  class="m-sm-form-control form-control" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION29.NAME_TITLE'|translate"/>
    </div>
    <div class="form-group col-12 col-md-3">
      <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION29.ADDRESS_TITLE"|translate}}
        </label>
      <input type="text" formControlName="borrowerAddress" class="m-sm-form-control form-control" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION29.ADDRESS_TITLE'|translate"/>
      <div class="m-error form-text" *ngIf="borrower.get('borrowerAddress').hasError('required') && displayErrors">
        {{ 'COMMON.FIELD_REQUIRED' | translate }}
      </div>
      <div class="m-error form-text" *ngIf="borrower.get('borrowerAddress').hasError('pattern') && displayErrors">
        {{ 'COMMON.NUM_LET_ONLY_PATTERN_ERROR' | translate }}
      </div>
    </div>
    <div class="form-group col-12 col-md-3">
      <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION29.CHILDREN_TITLE"|translate}}
        </label>
      <select formControlName="borrowerChildrenNumber" class="form-control m-sm-form-control" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION29.CHILDREN_TITLE'|translate">
          <option [value]="defaultValue">{{"BORROWERS_DETAILS.QUESTION29.CHILDREN_NUMBER_PH"|translate}}</option>
        <option *ngFor="let num of childrenNumber" [value]="num">{{num}}</option>
      </select>
      <div class="m-error form-text" *ngIf="borrower.get('borrowerChildrenNumber').hasError('required') && displayErrors">
        {{ 'COMMON.FIELD_REQUIRED' | translate }}
      </div>
    </div>
    <div class="form-group col-12 col-md-3">
      <label *ngIf="index===0" class="m-title">
          {{"BORROWERS_DETAILS.QUESTION29.MARITAL_STATUS_TITLE"|translate}}
        </label>
      <select formControlName="borrowerMaritalStatus" class="form-control m-sm-form-control" [attr.aria-label]="'BORROWERS_DETAILS.QUESTION29.MARITAL_STATUS_TITLE'|translate">
        <option [value]="defaultValue">{{"BORROWERS_DETAILS.QUESTION29.MARITAL_STATUS_PH"|translate}}</option>      
        <option *ngFor="let status of maritalStatus" [value]="status">{{status}}</option>
      </select>
      <div class="m-error form-text" *ngIf="borrower.get('borrowerMaritalStatus').hasError('required') && displayErrors">
        {{ 'COMMON.FIELD_REQUIRED' | translate }}
      </div>
    </div>
  <input type="hidden" formControlName="borrowerId" class="d-none1" /> 
</div>
</div> -->


// WEBPACK FOOTER //
// ./src/app/add-borrower/add-borrower.component.html